<template>
  <div class="content">
    <div class="user-management">
      <div class="container-fluid">
        <Card>
          <template #header>
            <div class="header-actions">
              <input v-model="searchTerm" type="text" class="search-input"
                placeholder="Search by email or description..." />
            </div>
          </template>

          <CustomTable :loading="loadingStates.table" :columns="tableColumns" :data="filteredBugs"
            :resetPage.sync="resetTableFlag">
            <template #email="{ item }">
              <span class="truncate-text">{{ item.email }}</span>
            </template>

            <template #description="{ item }">
              <span class="truncate-text">{{ item.description }}</span>
            </template>

            <template #timestamp="{ item }">
              {{ formatDate(item.timestamp) }}
            </template>

            <template #status="{ item }">
              <span :class="getStatusClass(item.status)">
                {{ item.status == "Resolved" ? "Resolved" : "Open" }}
              </span>
            </template>

            <template #open="{ item }">
              <button style="color: white;" class="btn-sm action-button" @click="openBug(item)">
                <span>Open</span>
              </button>
            </template>

            <template #action="{ item }">
              <button class="btn btn-sm action-button" @click="handleUpdateBugStatus(item)"
                :class="{ 'disabled-btn': item.status === 'Resolved' }"
                :disabled="loadingStates.updateStatus[item.id] || item.status === 'Resolved'">
                Mark as Resolved
              </button>
            </template>
          </CustomTable>
        </Card>

        <!-- Bug Details Modal -->
        <ReuseableModal :modelValue="isModalOpen" @update:modelValue="isModalOpen = $event" title="Bug Report Details"
          :hideSubmit="true" :scrollable="true" maxHeight="70vh" submitButtonText="Close" @submit="isModalOpen = false"
          :hideCancelButton="true">
          <div v-if="selectedBug" class="bug-detail">
            <p><strong>Email:</strong> {{ selectedBug.email || 'N/A' }}</p>
            <p><strong>Browser Name:</strong> {{ selectedBug.browserName || 'N/A' }}</p>
            <p><strong>OS Name:</strong> {{ selectedBug.osName || 'N/A' }}</p>
            <p><strong>Priority:</strong> {{ selectedBug.priority || 'N/A' }}</p>
            <p><strong>Status:</strong> {{ selectedBug.status == "Resolved" ? "Resolved" : "Open" }}</p>
            <p><strong>Reported On:</strong> {{ formatDate(selectedBug.timestamp) }}</p>

            <div class="mt-2">
              <strong>Description:</strong>
              <p class="description-box">{{ selectedBug.description }}</p>
            </div>

            <div style="display: flex; flex-direction: column;" v-if="selectedBug.screenshot" class="mt-3">
              <strong>Screenshot:</strong>
              <img :src="selectedBug.screenshot" class="bug-image" loading="lazy" />
            </div>
          </div>
        </ReuseableModal>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/components/UIComponents/Cards/Card.vue";
import CustomTable from "@/components/UIComponents/CustomTable.vue";
import ReuseableModal from "@/components/UIComponents/ReuseableModal.vue";
import { formatAdminActivityDate } from "@/utils/fileUtils";
import firebase from "@/assets/config/firebase";

export default {
  components: {
    Card,
    CustomTable,
    ReuseableModal
  },

  data() {
    return {
      searchTerm: "",
      resetTableFlag: false,
      bugList: [],
      selectedBug: null,
      isModalOpen: false,

      tableColumns: [
        { label: "Email", key: "email", sortable: true, sticky: "left" },
        { label: "Description", key: "description", sticky: "left" },
        { label: "Reported Date", key: "timestamp", sortable: true },
        { label: "Status", key: "status", sortable: true },
        { label: "Open Details", key: "open" },
        { label: "Action", key: "action", sticky: "right" }
      ],

      loadingStates: {
        table: false,
        updateStatus: {}
      }
    };
  },

  computed: {
    filteredBugs() {
      if (!this.searchTerm) return this.bugList;

      const term = this.searchTerm.toLowerCase();
      return this.bugList.filter(bug =>
        bug.email.toLowerCase().includes(term) ||
        bug.description.toLowerCase().includes(term)
      );
    }
  },

  mounted() {
    this.fetchReportedBugs();
  },

  methods: {
    async handleUpdateBugStatus(bug) {
      this.$set(this.loadingStates.updateStatus, bug.id, true);
      try {
        await firebase.updateBugStatus(bug.id);
        this.fetchReportedBugs();
        swal("Success", "Bug status updated successfully.", "success");
      } catch (error) {
        console.error("Failed to update bug status", error);
      } finally {
        this.$set(this.loadingStates.updateStatus, bug.id, false);
      }
    },
    formatDate(date) {
      return formatAdminActivityDate(date);
    },

    async fetchReportedBugs() {
      this.loadingStates.table = true;
      try {
        this.bugList = await firebase.getAllBugReports();
      } catch (err) {
        console.error("Failed to fetch bugs", err);
      } finally {
        this.loadingStates.table = false;
      }
    },

    openBug(bug) {
      this.selectedBug = bug;
      this.isModalOpen = true;
    },
    getStatusClass(status) {
      return (
        {
          "open": "status-badge pending",
          "Resolved": "status-badge approved",
        }[status] || "status-badge"
      );
    },
  },

  watch: {
    searchTerm() {
      this.resetTableFlag = true;
    }
  }
};
</script>

<style scoped>
.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.truncate-text {
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bug-detail p {
  margin-bottom: 8px;
}

.description-box {
  background: #fafafa;
  padding: 10px;
  border-radius: 4px;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.bug-image {
  max-width: 100%;
  border-radius: 6px;
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ReportedBugs/ReportedBugs.vue